// Statuses a proxy answers with when Genesis doesn't answer in time (or at all).
const GATEWAY_STATUSES = [502, 503, 504];

// How browsers word a request that got no response, or a proxy's HTML error page read as JSON.
const DROPPED_MESSAGES = [
  'Failed to fetch', // Chrome
  'NetworkError', // Firefox: "NetworkError when attempting to fetch resource."
  'Load failed', // Safari
  'Network request failed',
  'timeout',
  'Unexpected token', // Chrome: "Unexpected token '<', "<html>..." is not valid JSON"
  'JSON.parse', // Firefox: "JSON.parse: unexpected character at line 1 column 1 of the JSON data"
  'JSON Parse error' // Safari: "JSON Parse error: Unrecognized token '<'"
];

type RequestError = { message?: string; networkError?: { name?: string; statusCode?: number } | null } | string | null | undefined;

/**
 * Whether a deploy request failed because its connection did, not because the
 * deployment did. The request outlives the HTTP connection: after about a minute
 * the load balancer answers with its own HTML error page (504), while the
 * deployment carries on and its end comes over the socket. Apollo gives that
 * page as a ServerParseError with the status; a request with no response at
 * all only has the browser's message. Any other answer came from Genesis.
 */
export function isDroppedConnection(error: RequestError): boolean {
  if (!error) return false;
  if (typeof error !== 'string' && error.networkError && error.networkError.statusCode) {
    const { name, statusCode } = error.networkError;
    return name === 'ServerParseError' && GATEWAY_STATUSES.includes(statusCode);
  }
  const message = typeof error === 'string' ? error : error.message || '';
  return DROPPED_MESSAGES.some(x => message.includes(x));
}
